import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import { localApi, credentials, localApib2b } from "utils/imgApi";
import { BiEdit } from "react-icons/bi";
import Compressor from "compressorjs";
import PropTypes from "prop-types";
import Axios from "axios";
import CardAvatar from "components/Card/CardAvatar.js";
import defaultAvatar from "assets/img/placeholder.jpg";
import defaultImage from "assets/img/image_placeholder.jpg";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import styleDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import styleBtn from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

const style = {
  cardTitle,
  pageSubcategoriesTitle: {
    color: "#3C4858",
    textDecoration: "none",
    textAlign: "center",
  },
  cardCategory: {
    margin: "0",
    color: "#999999",
  },
};

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleDrop = makeStyles(styleDrop);
const useStyleSweet = makeStyles(styleSweet);
const useStyleBtn = makeStyles(styleBtn);

export default function ImagesAddLogo(props) {
  const [logoImg, setLogoImg] = React.useState("");
  const [firstname, setFristname] = React.useState("");
  const [lastname, setLastname] = React.useState("");
  const [submittedLogo, setSubmittedLogo] = React.useState(false);
  const [submittedDeleteLogo, setSubmittedDeleteLogo] = React.useState(false);
  const [userData, setUserData] = React.useState({});
  const [type, setType] = React.useState("");

  const [items, setItems] = React.useState([]);
  const [items1, setItems1] = React.useState([]);
  const [simpleSelect, setSimpleSelect] = React.useState("");
  const [simpleSelectErr, setSimpleSelectErr] = React.useState("");
  const [simpleSelect1, setSimpleSelect1] = React.useState("");
  const [simpleSelect1Err, setSimpleSelect1Err] = React.useState("");
  const [checkedFullSize, setCheckedFullSize] = React.useState(false);
  const [getId, setGetId] = React.useState("");
  const [getcatId, setGetcatId] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");

  const [newImage, setNewImage] = React.useState(false);
  const [btn, setBtn] = React.useState(false);

  const classes = useStyles();
  const classe = useStyle();
  const classDrop = useStyleDrop();
  const history = useHistory();
  const classSweet = useStyleSweet();
  const classBtn = useStyleBtn();

  const { search } = useLocation();
  const a = new URLSearchParams(search).get("a");

  const [file, setFile] = React.useState(null);
  const [fileLogo, setFileLogo] = React.useState(null);
  const [fileErr, setFileErr] = React.useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
    props.avatar ? "" : ""
  );
  const [imagePreviewUrlLogo, setImagePreviewUrlLogo] = React.useState(
    props.avatar ? defaultAvatar : defaultImage
  );
  let fileInput = React.createRef();
  let fileInputSign = React.createRef();
  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      setFile(file);
      setImagePreviewUrl(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
    setFileErr("");
  };

  const handleImageChangeLogo = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      setFileLogo(file);
      setImagePreviewUrlLogo(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleClick = () => {
    fileInput.current.click();
  };
  const handleClickLogo = () => {
    fileInputSign.current.click();
  };

  const handleRemove = () => {
    setFile(null);
    setImagePreviewUrl(props.avatar ? "" : "");
    fileInput.current.value = null;
  };
  const handleRemoveLogo = () => {
    setFileLogo(null);
    setImagePreviewUrlLogo(props.avatar ? defaultAvatar : defaultImage);
    fileInputSign.current.value = null;
  };

  let { avatar, addButtonProps, changeButtonProps, removeButtonProps } = props;

  async function getCat() {
    const api = localApib2b + `/admin/byId/${a}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    setUserData(getResult);
    setFristname(getResult.firstname);
    setLastname(getResult.lastname);
    // setSignImg(getResult.signatureUrl + "?id=" + getResult.id);
    setLogoImg(getResult.logoUrl + "?id=" + getResult.id);

    const apiType = localApib2b + `/type/list`;
    const resultType = await fetch(apiType, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResultType = await resultType.json();
    const typeDes = getResultType.TypeList.filter((f) => f.typeId === getResult.typeId)[0];
    setType(typeDes);
  }

  useEffect(() => {
    getCat();
    // catApi().then((res) => setItems(res));
  }, []);

  const hideAlertLogo = () => {
    setSubmittedLogo(false);
    window.location.reload(false);
  };

  const hideAlertDeleteLogo = () => {
    setSubmittedDeleteLogo(false);
    window.location.reload(false);
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  // const handleSubmitLogo = async (e) => {
  //   e.preventDefault();
  //   let fData = new FormData();
  //   fData.append("logoImage", fileLogo || new File([""], ""));
  //   Axios.put(localApib2b + `/admin/update/logo/findById/${a}`, fData, {
  //     headers: {
  //       Authorization: `Basic ${credentials}`,
  //     },
  //   }).then((data) => {
  //     // console.log(data.data);
  //     if (data.data.message === "Data Updated Successfully !!!") {
  //       alertTypeOps("success");
  //       alertMsgOps("Succesfully !!!");
  //       setSubmittedLogo(true);
  //     }
  //     // window.location.reload(false);
  //   });
  // };

  const handleSubmitLogo = async () => {
    if (!fileLogo) {
      // alert("Please upload an image.");
      alertTypeOps("danger");
      alertMsgOps("Please upload an logo.");
      setSubmitted(true);
      return;
    }

    const img = new Image();
    const objectUrl = URL.createObjectURL(fileLogo);

    img.onload = async () => {
      if (img.width === 76 && img.height === 76) {
        let fData = new FormData();
        fData.append("logoImage", fileLogo);

        try {
          const response = await Axios.put(
            localApib2b + `/admin/update/logo/findById/${a}`,
            fData,
            {
              headers: {
                Authorization: `Basic ${credentials}`,
              },
            }
          );

          if (response.data.message === "Data Updated Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Successfully updated!");
            setSubmittedLogo(true);
          }
        } catch (error) {
          console.error("Upload failed:", error);
          // alert("Failed to upload image.");
          alertTypeOps("danger");
          alertMsgOps("Failed to upload logo.");
          setSubmitted(true);
        }
      } else {
        // alert("Image dimensions must be 840x1124 pixels.");
        alertTypeOps("danger");
        alertMsgOps("Logo dimensions must be 76x76 pixels.");
        setSubmitted(true);
      }

      // Clean up the object URL
      URL.revokeObjectURL(objectUrl);
    };

    img.onerror = () => {
      // alert("Invalid image file.");
      alertTypeOps("danger");
      alertMsgOps("Invalid logo file.");
      setSubmitted(true);
      URL.revokeObjectURL(objectUrl);
    };

    img.src = objectUrl;
  }

  const SubmitDeleteLogo = () => {
    // setBtn(true);
    fetch(localApib2b + `/admin/update/deleteLogo/findById/${a}`, {
      method: "PUT",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        // console.log(res);
        if (res.message === "Data Updated Successfully !!!") {
          alertTypeOps("success");
          alertMsgOps("Succesfully !!!");
          setSubmittedDeleteLogo(true);
        }
      });
  };

  return (
    <div className={classes.container}>
      {submitted && (
        <SweetAlert
          type={alertType}
          style={{ display: "block", marginTop: "-100px" }}
          title={alertMsg}
          onConfirm={() => hideAlert()}
          confirmBtnCssClass={classSweet.button + " " + classSweet.success}
        />
      )}
      {submittedLogo ? (
        <SweetAlert
          type={alertType}
          style={{ display: "block", marginTop: "-100px" }}
          title={alertMsg}
          onConfirm={() => hideAlertLogo()}
          confirmBtnCssClass={classSweet.button + " " + classSweet.success}
        >
          Updated Logo
        </SweetAlert>
      ) : null}
      {submittedDeleteLogo ? (
        <SweetAlert
          type={alertType}
          style={{ display: "block", marginTop: "-100px" }}
          title={alertMsg}
          onConfirm={() => hideAlertDeleteLogo()}
          confirmBtnCssClass={classSweet.button + " " + classSweet.success}
        >
          Delete Logo
        </SweetAlert>
      ) : null}
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <Card profile>
            <CardAvatar profile>
              <a href="#pablo" onClick={(e) => e.preventDefault()}>
                <img src={logoImg} alt="..." />
              </a>
            </CardAvatar>
            <CardBody profile>
              <h5 className={classBtn.cardCategory}>
                {/* CEO / CO-FOUNDER */}
                {type.descType}
              </h5>
              <h3 className={classBtn.cardTitle}>
                {firstname + "  " + lastname}
              </h3>
              <p className={classBtn.description}>
                In this ever-changing society, the most powerful and enduring
                brands are built from the heart. They are real and sustainable.
                Their foundations are stronger because they are built with the
                strength of the human spirit. Don’t limit yourself. Many people
                limit themselves to what they think they can do. You can go as
                far as your mind lets you. What you believe, remember, you can
                achieve.
              </p>

              <legend>
                My Logo Image* <br /> Logo dimension Must be 76x76
              </legend>
              <div className="fileinput text-center">
                <input
                  type="file"
                  onChange={handleImageChangeLogo}
                  ref={fileInputSign}
                />
                {fileLogo && (
                  <div className={"thumbnail" + (avatar ? " img-circle" : "")}>
                    <img src={imagePreviewUrlLogo} alt="..." />
                  </div>
                )}

                <div>
                  {fileLogo === null ? (
                    <Button
                      color="rose"
                      round
                      {...addButtonProps}
                      onClick={() => handleClickLogo()}
                    >
                      {avatar ? "Select Logo" : "Select Logo"}
                    </Button>
                  ) : (
                    <span>
                      <Button
                        color="rose"
                        round
                        {...changeButtonProps}
                        onClick={() => handleClickLogo()}
                      >
                        Change
                      </Button>
                      {avatar ? <br /> : null}
                      <Button
                        color="rose"
                        round
                        {...removeButtonProps}
                        onClick={() => handleRemoveLogo()}
                      >
                        <i className="fas fa-times" /> Remove
                      </Button>
                      <Button color="rose" round onClick={handleSubmitLogo}>
                        upload Logo
                      </Button>
                    </span>
                  )}
                  {fileLogo ? (
                    ""
                  ) : (
                    <Button color="rose" round onClick={SubmitDeleteLogo}>
                      Delete Logo
                    </Button>
                  )}
                </div>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

ImagesAddLogo.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
